import {eases} from "./eases";

export function getKeyframeAnimation(element, settings, animationcalculation, direction){
    //check settings && settings.tweens to be set, if not return a default animation.
    if(!settings || !settings.tweens){
        return {
            opacity:0
        }
    }

    const animation = {
        frames: []
    }
    const uuid = element[0].id;

    settings.tweens.forEach((tween, i) => {
        const duration = tween.settings.duration || (animationcalculation.viewport.height / 3);
        const from = Object.assign({}, settings.keyframes[i])
        const to = {
            ...settings.keyframes[i+1],
            duration: duration / (tween.settings.acceleration ?? 1),
            // immediateRender: true,
            immediateRender: i === 0,
            ease: eases[tween.ease],
        }
        const path = animationcalculation.scene.querySelector(`#path-${uuid}-${direction}-${i}`) ?? animationcalculation.scene.querySelector(`#path-${uuid}-${i}`)
        to.motionPath = {
            path,
            align: path,
            // path: `#path-${uuid}-${i}`,
            // align: `#path-${uuid}-${i}`,
            alignOrigin: [0.5, 0.5],
            autoRotate: tween.autoRotate ?? false,
        }
        const data = settings.tweens[i].settings;

        animation.frames.push({from, to, data})
    })
    return animation

    // return {frames: [
    //     {from: { background: 'red' }, to: { duration: 2, motionPath, background: 'red' }},
    //     {from: { background: 'red' }, to: { duration: 2, motionPath, background: '#0c4b69' }},
    //     // {from: { background: 'red' }, to: { duration: 1, motionPath: 'M 0 0 Q 100 300 0 400', background: 'red' }},
    //     // {from: { background: 'red' }, to: { duration: 1, motionPath: 'M 0 0 Q 100 300 0 400', background: 'red' }},
    //     // {from: { background: 'red' }, to: { duration: 1, motionPath: 'M 0 0 Q 100 300 0 400', background: 'red' }}
    // ]}
}
